@if (hrisIntegrationDataService.hrisIntegration; as hrisIntegration) {
  <div
    class="flex w-full items-center justify-center gap-2 rounded-lg bg-grey-veryLightGrey px-5 py-3"
  >
    <mat-icon class="material-icons-outlined hvs-icon-xxl text-blue-dark">
      link
    </mat-icon>
    <p class="text-base font-semibold">
      <span class="text-blue-dark">{{ hrisIntegration.providerName }}:</span>
      <span [class]="statusClass">
        {{
          'portal.hrisIntegration.statuses.' + hrisIntegration.status
            | transloco
        }}
      </span>
    </p>
  </div>
} @else {
  <app-hris-integration-setup-button />
}
